"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendUserAgentIfBackend = void 0;
const axios_1 = require("axios");
const constants_1 = require("./constants");
function extendUserAgentIfBackend(userAgentPrefix, config) {
    if (isBackend()) {
        extendUserAgent(userAgentPrefix, config);
    }
}
exports.extendUserAgentIfBackend = extendUserAgentIfBackend;
function extendUserAgent(userAgentPrefix, config) {
    if (!config.headers) {
        config.headers = new axios_1.AxiosHeaders({});
    }
    if (!config.clientName) {
        console.log("We recommend providing the `clientName` when instantiating a NetworkProvider (e.g. ProxyNetworkProvider, ApiNetworkProvider). This information will be used for metrics collection and improving our services.");
    }
    const headers = axios_1.AxiosHeaders.from(config.headers).normalize(true);
    const resolvedClientName = config.clientName || constants_1.UnknownClientName;
    const currentUserAgent = headers.hasUserAgent() ? headers.getUserAgent() : "";
    const newUserAgent = currentUserAgent
        ? `${currentUserAgent} ${userAgentPrefix}/${resolvedClientName}`
        : `${userAgentPrefix}/${resolvedClientName}`;
    headers.setUserAgent(newUserAgent, true);
}
function isBackend() {
    return typeof window === "undefined";
}
//# sourceMappingURL=userAgent.js.map